import { Component, ViewChild } from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import {
  FileInfo,
  FileRestrictions,
  RemoveEvent,
  SelectEvent,
  UploadEvent,
} from '@progress/kendo-angular-upload';
import { SharedService } from '../../../shared/shared.service';
import { Validations } from '../../../shared/constants/validations';
import { LoaderService } from '../../../core/services/loader.service';
import { UtilitesService } from '../../../core/services/utilities.services';
import { MeterService } from '../../../core/services/meter.services';
import { error } from 'console';
import { SweetAlertIcon,Roles } from '../../../shared/constants/enum';

import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import {
  process,
  State,
  toODataString,
  SortDescriptor,
} from '@progress/kendo-data-query';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import {
  table_pageSize,
  Templates,
} from '../../../shared/constants/templatesNames';
import {
  FilterableSettings,
  DataBindingDirective,
  GridDataResult,
  PageChangeEvent,
  DataStateChangeEvent,
  GridComponent,
  SelectableSettings,
} from '@progress/kendo-angular-grid';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker/bs-datepicker.config';
import { PdfexportService } from '../../../core/services/pdfexport.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

export interface MeterPhotoDto {
  id: string;
  fileName: string;
  photoUrl: string;
}

export interface MeterDetails {
  photoUrl: MeterPhotoDto[];
}

@Component({
  selector: 'app-edit-meters',
  templateUrl: './edit-meters.component.html',
  styleUrl: './edit-meters.component.scss',
  standalone: false,
})
export class EditMetersComponent {
  private isUnmappedLocally = false;
  @ViewChild('cdkStepper') cdkStepper: any;
  regex = /^[A-Z0-9]*$/;
  modalRefReasons!: BsModalRef;
  imagePreviewModalRef!: BsModalRef;
  gatewayregex = /^[a-zA-Z0-9]+$/;
  onlynumber = /^\d+$/;
  Macregex = /^[0-9A-F]+$/;
  IsWiredMacregex = /^[0-9]+$/;
  SerialIswired = /^[A-Z0-9]+$/;
  metresdatePickerConfig: Partial<BsDatepickerConfig> | undefined;
  datePickerConfig: Partial<BsDatepickerConfig>;
  Umd_Validations = Validations.UmdCreatePage;
  mappingDBMetersForm!: UntypedFormGroup;
  editDBMetersForm!: UntypedFormGroup;
  iswirdeCommunication: boolean = false;
  selectedutlity: any;
  Roles = Roles;
  selectedresidenatilUnit: any;
  conficdatabyProject: any = [];
  public currentImageIndex = 0;
  gatewayLists: any = [];
  reason: any;
  public readonly maxPhotoSize = 5 * 1024 * 1024;
  public readonly maxPhotoCount = 10;
  myRestrictions: FileRestrictions = {
    allowedExtensions: ['.jpg', '.jpeg', '.png'],
    maxFileSize: this.maxPhotoSize,
  };
  public fileImages: Array<FileInfo> | undefined;
  prifileValidations = Validations.metersDbPage;
  meterId: any;
  macAddress: any;
  configData: any = [];
  isUploading: boolean = false;
  uploadLocked: boolean = false;
  private uploadingPhotoCount = 0;
  private pendingPhotoIds = new Set<string>();
  submitted: boolean = false;
  isSubmitted: boolean = false;
  url: any = '';
  uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
  uploadRemoveUrl = 'removeUrl'; // should represent an actual API endpoint
  breadCrumbItems: Array<{}> | undefined;
  metersDBData: (MeterDetails & any) | null = null;
  meterPhotos: MeterPhotoDto[] = [];
  isMapResidenatiUnit: boolean = false;
  selectedGateways: any;
  /* mapping Histroty */
  @ViewChild('pdfGrid') public hiddenGrid: GridComponent | undefined;
  public selectableSettings: SelectableSettings = {
    mode: 'multiple',
    checkboxOnly: true,
  };

  searchModifiedData: any;
  public meterState: any = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  config: any = {
    backdrop: true,
    ignoreBackdropClick: true,
  };
  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective | undefined;
  public pageSize = 10;
  public skip = 0;
  totalMasterCount: number = 0;
  currentPage: number = 1;
  meterDBlistList: any[] = [];
  public sort: SortDescriptor[] = [];
  public meterDBgridData: GridDataResult = { data: [], total: 0 };
  public filter: CompositeFilterDescriptor = { logic: 'and', filters: [] };
  mySelectionMeter: any = [];
  orderByQuery: string = '';
  queryString: string = '';
  searchedValue: any = '';
  public buttonCount = 5;
  regex_Alphanumeric = '^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$';
  initialReadingExp = '^\\d+(\\.\\d{1,2})?$';
  public info = true;
  public type: 'numeric' | 'input' = 'numeric';
  public pageSizes = table_pageSize.pageSizes;
  minDate: any;
  public previousNext = true;
  currentUser: any;
  Project_startDate: any;
  reasonError: boolean = false;
  userId: any;
  today: any;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private loaderService: LoaderService,
    private sharedService: SharedService,
    private utilitesService: UtilitesService,
    private meterService: MeterService,
    private pdfexportService: PdfexportService,
    private modalService: BsModalService,
    private router: Router,
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') ?? '');
    this.userId = this.currentUser?.currentUserRoleDetails.userId;

    this.datePickerConfig = Object.assign(
      {},
      {
        dateInputFormat: 'DD/MM/YYYY', // Set to dd/MM/yyyy format
        showWeekNumbers: false,
        isAnimated: true,
        containerClass: 'theme-dark-blue',
      },
    );
    this.metresdatePickerConfig = {
      containerClass: 'theme-dark-blue',
      rangeSeparator: ' to ',
      dateInputFormat: 'DD/MM/YYYY',
      // minDate: this.minDate,
      maxDate: new Date(),
      showWeekNumbers: false,

      // other configurations as needed
    };
    this.breadCrumbItems = [
      { label: 'Meters Database', url: 'metersDatabase', active: true },
      { label: ' Edit Meters Database', active: true },
    ];
    this.today = new Date();
    if (
      history.state.MetersId != undefined &&
      history.state.MetersId !== null
    ) {
      this.meterId = history.state.MetersId;
      this.macAddress = history.state.macAddress;
    }
    this.getAllConfigData();
  }
  waterTypeItems: any = [];
  meterUtilities: any[] = [];
  getAllConfigData(): void {
    let payload = ['utilities', 'projects', 'suppliers'];

    this.sharedService.getAllConfigData(payload).subscribe((res) => {
      if (
        res.statusCode === 200 &&
        res.message === 'Config data retrieved successfully.'
      ) {
        this.configData = res.data;
        this.meterUtilities = this.getMeterUtilities(
          this.configData?.utilities,
        );
        /*  this.waterTypeItems = this.configData?.suppliers.filter((item: any) => {
           return item.master.name.toLowerCase() === event.name.toLowerCase();
         });
         console.log(this.waterTypeItems) */
        this.getmetersDbByid();
        //this.loaderService.setLoading(false);
      }
    });
  }

  private getMeterUtilities(utilities: any[] = []): any[] {
    return utilities.filter(
      (utility: any) => utility?.name?.toString().trim().toLowerCase() !== 'ev',
    );
  }

  ngOnInit(): void {
    this.mappingDBMetersForm = this.formBuilder.group({
      projectIds: [null, Validators.required],
      residentialUnit: [null, Validators.required],
      gatewayInformationId: [null],
      files: [this.fileImages],
      location: [],
      installed_Location: [''],
      meterReadingIndex: [''],
      initialReading: [''],
      meter_Initial_Reading_EB_KWH: [''],
      meter_Initial_Reading_DG_KWH: [''],
      meterInstallation_Date: [null],
      meter_InitialReadingDate: [null],
      meter_Initial_Reading_Solar_KWH: [''],
    });
    this.editForm();

    //this.DBMetersForm.disable();
  }
  editForm() {
    this.editDBMetersForm = this.formBuilder.group({
      utilityMasterId: [, Validators.required],
      isWiredCommunicationDevice: [false],
      deviceId: [''],
      supplierId: [null],
      meterSerialNo: [
        '',
        [
          Validators.required,
          Validators.pattern(this.regex),
          Validators.maxLength(16),
          Validators.minLength(7),
        ],
      ],

      macAddress: [
        '',
        [
          Validators.required,
          Validators.pattern(this.Macregex),
          Validators.maxLength(16),
          Validators.minLength(16),
        ],
      ],
    });
  }

approvalConfiramation(type: any, model: any) {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-outline-primary ms-2',
    },
    buttonsStyling: false,
  });

  let statusText = '';

  if (type === 'approve') {
    if (this.metersDBData?.approvalStatus === 'AgentMapped') {
      statusText = 'Link';
    } else if (this.metersDBData?.approvalStatus === 'AgentUnmapped') {
      statusText = 'Unlink';
    }
  } else if (type === 'reject') {
    statusText = 'Reject';
  }

  swalWithBootstrapButtons
    .fire({
      title: 'Are you sure?',
      text: `Do you want to ${statusText}?`,
      icon: 'warning',
      confirmButtonText: 'Yes, Proceed',
      cancelButtonText: 'No, Cancel',
      showCancelButton: true,
    })
    .then((result) => {
      if (result.isConfirmed) {
        console.log(type);

        if (type === 'approve') {
          this.approval();
        } else if (type === 'reject') {
          this.rejectModel(model);
        }
      }
    });
}
  approval() {
    this.loaderService.setLoading(true);
    let request = {
      meterId: this.meterId,
      macAddress: this.macAddress,
      //  reason: 'string',
      userID: this.userId,

      mapType: this.metersDBData?.approvalStatus,
    };

    this.meterService.approveMetersDB(request).subscribe({
      next: (res) => {
        if (res.statusCode === 200) {
          this.router.navigate(['/metersDatabase']);
          this.sharedService.showMessageDialog(
            res.message,
            '',
            SweetAlertIcon.SUCCESS,
          );
          this.loaderService.setLoading(false);
        }
      },
      error: (err) => {
        console.log(err);
        this.loaderService.setLoading(false);

        // Check if backend returned an error.message
        const errorMsg =
          err.error?.message || 'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR,
        );
      },
    });
  }

  reject() {
    this.loaderService.setLoading(true);
    const reason = (this.reason ?? '').trim();
    let request = {
      meterId: this.meterId,
      macAddress: this.macAddress,
      reason: this.reason,
      failedReason: reason,
      userID: this.userId,
      mapType: this.metersDBData?.approvalStatus,
    };

    this.meterService.rejectMetersDB(request).subscribe({
      next: (res) => {
        if (res.statusCode === 200) {
          this.router.navigate(['/metersDatabase']);
          this.sharedService.showMessageDialog(
            res.message,
            '',
            SweetAlertIcon.SUCCESS,
          );
          this.loaderService.setLoading(false);
        }
      },
      error: (err) => {
        console.log(err);
        this.loaderService.setLoading(false);

        // Check if backend returned an error.message
        const errorMsg =
          err.error?.message || 'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR,
        );
      },
    });
  }
  getmetersDbByid() {
    this.loaderService.setLoading(true);
    console.log(this.meterId);
    console.log(this.macAddress, 'mac');
    this.meterService.getMetersDBbyId(this.meterId).subscribe({
      next: (res) => {
        console.log('metersDb------>', res);
        if (res.statusCode == 200) {
          this.metersDBData = res.data;
          this.macAddress = this.metersDBData?.macAddress;
          console.log(
            this.metersDBData?.projectId,
            this.metersDBData?.macAddress,
          );
          this.featchDBData();
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  featchDBData() {
    console.log(this.metersDBData);

    if (
      this.metersDBData?.approvalStatus === 'AgentMapped' ||
      this.metersDBData?.approvalStatus === 'AgentUnmapped'
    ) {
      console.log(this.metersDBData?.approvalStatus);
      this.editDBMetersForm.disable();
      this.mappingDBMetersForm.disable();
    } else if (this.metersDBData?.approvalStatus === 'Rejected') {
      // Rejected meters can be corrected in both the meter details and mapping sections.
      this.editDBMetersForm.enable();
      this.mappingDBMetersForm.enable();
    } else if (this.metersDBData?.approvalStatus === 'NotStarted') {
      this.editDBMetersForm.enable();
      this.mappingDBMetersForm.enable();
    } else if (this.metersDBData?.mappingDetails?.projectID) {
      this.editDBMetersForm.disable();
      this.mappingDBMetersForm.disable();
    } else {
      this.editDBMetersForm.enable();
      this.mappingDBMetersForm.enable();
    }
    this.selectedGateways = {
      id: this.metersDBData?.gatewayInformationId,
      gatewaySerialNumber: this.metersDBData?.gatewayName,
    };

    this.setMeterPhotosFromResponse();
    this.currentImageIndex = 0;
    this.imageSrc = this.imagePreviews[0] ?? null;
    this.selectedutlity = {
      id: this.metersDBData?.utilityMasterId,
      name: this.metersDBData?.currentUtilityType,
    };
    this.waterTypeItems = this.configData?.suppliers.filter((item: any) => {
      return (
        item.master.name.toLowerCase() ===
        this.metersDBData?.currentUtilityType?.toLowerCase()
      );
    });
    console.log(this.waterTypeItems);

    this.editDBMetersForm.patchValue({
      utilityMasterId: this.metersDBData?.utilityMasterId,
      meterSerialNo: this.metersDBData?.meterSerialNo,
      macAddress: this.metersDBData?.macAddress,
      isWiredCommunicationDevice: this.metersDBData?.isWiredCommunicationDevice,
      deviceId: this.metersDBData?.deviceId,
      supplierId: this.metersDBData?.supplierId ?? null,
    });
    if (this.metersDBData?.isWiredCommunicationDevice) {
      this.mappingDBMetersForm
        .get('gatewayInformationId')
        ?.setValidators([Validators.required]);
    }

    this.mappingDBMetersForm.patchValue({
      location:
        typeof this.metersDBData?.location === 'string' &&
        this.metersDBData.location.trim().toLowerCase() === 'not available'
          ? ''
          : this.metersDBData?.location ?? '',
      gatewayInformationId: this.metersDBData?.gatewayInformationId,
    });
    const hasMappingData = Boolean(
      (this.metersDBData?.mappingDetails &&
        Object.keys(this.metersDBData.mappingDetails).length > 0) ||
        this.metersDBData?.projectId ||
        this.metersDBData?.residentialUnitID ||
        this.metersDBData?.residentialUnitId ||
        this.metersDBData?.installedLocation ||
        this.metersDBData?.initialReading ||
        this.metersDBData?.meterInitialReadingEBKWH ||
        this.metersDBData?.meterInitialReadingDGKWH ||
        this.metersDBData?.meterInitialReadingSolarKWH ||
        this.metersDBData?.meterInstallationDate ||
        this.metersDBData?.initialReadingDate,
    );

    if (
      this.metersDBData?.approvalStatus !== 'Rejected' &&
      hasMappingData
    ) {
      console.log(this.metersDBData.mappingDetails?.residentialUnitID);
      this.mappingDBMetersForm.patchValue({
        projectIds:
          this.metersDBData.mappingDetails?.projectID ??
          this.metersDBData?.projectId ??
          null,
        residentialUnit:
          this.metersDBData.mappingDetails?.residentialUnitID ??
          this.metersDBData?.residentialUnitID ??
          this.metersDBData?.residentialUnitId ??
          null,
        installed_Location:
          this.metersDBData.mappingDetails?.installedLocation ??
          this.metersDBData?.installedLocation ??
          '',
        meterReadingIndex:
          this.metersDBData.mappingDetails?.meterReadingIndex ??
          this.metersDBData.mappingDetails?.meterReadingIndexValue ??
          this.metersDBData?.meterReadingIndex ??
          '',

        initialReading:
          this.metersDBData.mappingDetails?.initialReading ??
          this.metersDBData?.initialReading ??
          '',
        meter_Initial_Reading_EB_KWH:
          this.metersDBData.mappingDetails?.meterInitialReadingEBKWH ??
          this.metersDBData?.meterInitialReadingEBKWH ??
          '',
        meter_Initial_Reading_DG_KWH:
          this.metersDBData.mappingDetails?.meterInitialReadingDGKWH ??
          this.metersDBData?.meterInitialReadingDGKWH ??
          '',
        meter_Initial_Reading_Solar_KWH:
          this.metersDBData.mappingDetails?.meterInitialReadingSolarKWH ??
          this.metersDBData?.meterInitialReadingSolarKWH ??
          '',
        meterInstallation_Date: this.metersDBData.mappingDetails
          ?.meterInstallationDate
          ? new Date(this.metersDBData.mappingDetails.meterInstallationDate)
          : this.metersDBData?.meterInstallationDate
            ? new Date(this.metersDBData.meterInstallationDate)
          : null,
        meter_InitialReadingDate: this.metersDBData.mappingDetails
          ?.initialReadingDate
          ? new Date(this.metersDBData.mappingDetails.initialReadingDate)
          : this.metersDBData?.initialReadingDate
            ? new Date(this.metersDBData.initialReadingDate)
          : null,
      });
    } else {
      this.fileImages = [];
      this.mappingDBMetersForm.patchValue({
        projectIds: null,
        residentialUnit: null,
        gatewayInformationId:
          this.metersDBData?.approvalStatus === 'Rejected'
            ? null
            : this.metersDBData?.gatewayInformationId ?? null,
        files:
          this.metersDBData?.approvalStatus === 'Rejected' ? [] : this.fileImages,
        location:
          this.metersDBData?.approvalStatus === 'Rejected'
            ? null
            : this.metersDBData?.location ?? null,
        installed_Location: '',
        meterReadingIndex:
          this.metersDBData?.approvalStatus === 'Rejected'
            ? ''
            : this.metersDBData?.meterReadingIndex ?? '',
        initialReading: '',
        meter_Initial_Reading_EB_KWH: '',
        meter_Initial_Reading_DG_KWH: '',
        meter_Initial_Reading_Solar_KWH: '',
        meterInstallation_Date: null,
        meter_InitialReadingDate: null,
      });
      if (this.metersDBData?.approvalStatus === 'Rejected') {
        this.selectedGateways = null;
        this.mappingDBMetersForm.get('files')?.setValue([]);
      }
    }
    console.log(this.mappingDBMetersForm.get('location')?.value);
    this.iswirdeCommunication = this.metersDBData?.isWiredCommunicationDevice;
    console.log(this.iswirdeCommunication);
    console.log(this.metersDBData?.currentUtilityType);
    this.utilityBasedValidation();
    if (['NotStarted', 'Rejected'].includes(this.metersDBData?.approvalStatus)) {
      // Uploaded mapping values remain editable while the record is pending,
      // including utility-specific reading/date fields.
      this.mappingDBMetersForm.enable();
    }
    if (this.isUnmappedLocally && this.isSuperAdminOrSuperUser()) {
      this.mappingDBMetersForm.enable();
    }
    if (this.isLocationCoordinatesDisabled()) {
      this.mappingDBMetersForm.get('location')?.disable({ emitEvent: false });
    }
    console.log(this.metersDBData?.isWiredCommunicationDevice);
    if (this.metersDBData?.isWiredCommunicationDevice) {
      // When checkbox is checked, add the required validators
      this.f['macAddress'].setValidators([
        Validators.required,
        Validators.pattern(this.IsWiredMacregex),
        Validators.maxLength(7),
        Validators.minLength(7),
      ]);
      this.f['meterSerialNo'].setValidators([
        Validators.required,
        Validators.pattern(this.SerialIswired),
        Validators.maxLength(7),
        Validators.minLength(7),
      ]);
      this.f['deviceId'].setValidators([
        Validators.required,
        Validators.pattern(this.onlynumber),
      ]);
      this.f['macAddress'].updateValueAndValidity();
      this.f['meterSerialNo'].updateValueAndValidity();
      this.f['deviceId'].updateValueAndValidity();
    } else {
      this.f['deviceId'].clearValidators();
      this.f['macAddress'].setValidators([
        Validators.required,
        Validators.pattern(this.Macregex),
        Validators.maxLength(16),
        Validators.minLength(16),
      ]);
      this.f['meterSerialNo'].setValidators([
        Validators.required,
        Validators.pattern(this.regex),
        Validators.maxLength(16),
        Validators.minLength(7),
      ]);
      this.f['macAddress'].updateValueAndValidity();
      this.f['meterSerialNo'].updateValueAndValidity();
      this.f['deviceId'].updateValueAndValidity({}); // Update validity without triggering events
    }
    // A meter's DB details are fixed after creation, regardless of approval status.
    this.editDBMetersForm.disable({ emitEvent: false });
    this.loaderService.setLoading(false);
  }
  formatDate(date: string | Date | null): string | null {
    if (!date) return null;

    const d = new Date(date);
    if (isNaN(d.getTime())) return null;

    // for <input type="date"> → 'YYYY-MM-DD'
    return d.toISOString().split('T')[0];
  }
  utilityBasedValidation() {
    if (!this.metersDBData?.projectId) {
      /*  this.mapping['initialReading'].enable();
      this.mapping['meter_Initial_Reading_EB_KWH'].enable();
      this.mapping['meter_Initial_Reading_DG_KWH'].enable();
      this.mapping['meter_Initial_Reading_Solar_KWH'].enable();
      this.mapping['meterInstallation_Date'].enable();
      this.mapping['meter_InitialReadingDate'].enable(); */

      console.log(this.metersDBData?.projectId);
      const type = this.getSelectedUtilityName().toLowerCase();

      const utilityBasedFields = [
        'initialReading',
        'meter_Initial_Reading_EB_KWH',
        'meter_Initial_Reading_DG_KWH',
        'meter_Initial_Reading_Solar_KWH',
        'meterReadingIndex',
      ];

      utilityBasedFields.forEach((field) => {
        this.mapping[field].clearValidators();
        this.mapping[field].updateValueAndValidity({ emitEvent: false });
      });

      if (type === 'trisource') {
        // EB
        this.mapping['meter_Initial_Reading_EB_KWH'].setValidators([
          Validators.required,
          Validators.pattern(this.initialReadingExp),
          this.maxLimitValidator(99999),
        ]);

        // DG
        this.mapping['meter_Initial_Reading_DG_KWH'].setValidators([
          Validators.required,
          Validators.pattern(this.initialReadingExp),
          this.maxLimitValidator(99999),
        ]);

        // Solar
        this.mapping['meter_Initial_Reading_Solar_KWH'].setValidators([
          Validators.required,
          Validators.pattern(this.initialReadingExp),
          this.maxLimitValidator(99999),
        ]);

        this.mapping['meter_Initial_Reading_EB_KWH'].updateValueAndValidity();
        this.mapping['meter_Initial_Reading_DG_KWH'].updateValueAndValidity();
        this.mapping[
          'meter_Initial_Reading_Solar_KWH'
        ].updateValueAndValidity();
      } else if (type === 'electricity') {
        // EB
        this.mapping['meter_Initial_Reading_EB_KWH'].setValidators([
          Validators.required,
          Validators.pattern(this.initialReadingExp),
          this.maxLimitValidator(99999),
        ]);

        // DG
        this.mapping['meter_Initial_Reading_DG_KWH'].setValidators([
          Validators.required,
          Validators.pattern(this.initialReadingExp),
          this.maxLimitValidator(99999),
        ]);

        this.mapping['meter_Initial_Reading_EB_KWH'].updateValueAndValidity();
        this.mapping['meter_Initial_Reading_DG_KWH'].updateValueAndValidity();
      } else if (type === 'gas' || type === 'water') {
        // Initial Reading
        this.mapping['initialReading'].setValidators([
          Validators.required,
          Validators.pattern(this.initialReadingExp),
          this.maxLimitValidator(99999999),
        ]);
        this.mapping['initialReading'].updateValueAndValidity();
      }

      if (type === 'gas') {
        this.mapping['meterReadingIndex'].setValidators([
          Validators.required,
          Validators.maxLength(8),
          Validators.minLength(8),
          Validators.pattern(/^\d+$/),
        ]);
      }
      this.mapping['meterReadingIndex'].updateValueAndValidity();

      // Installed Location → required when projectId is empty
      this.mapping['installed_Location'].setValidators([
        Validators.required,
        Validators.pattern(this.regex_Alphanumeric),
        Validators.maxLength(25),
      ]);
      this.mapping['meterInstallation_Date'].setValidators([
        Validators.required,
      ]);
      this.mapping['meter_InitialReadingDate'].setValidators([
        Validators.required,
      ]);
      this.mapping['meterInstallation_Date'].updateValueAndValidity();
      this.mapping['meter_InitialReadingDate'].updateValueAndValidity();
      this.mapping['installed_Location'].updateValueAndValidity();
    } else {
      this.mapping['initialReading'].disable();
      this.mapping['meter_Initial_Reading_EB_KWH'].disable();
      this.mapping['meter_Initial_Reading_DG_KWH'].disable();
      this.mapping['meter_Initial_Reading_Solar_KWH'].disable();
      this.mapping['meterInstallation_Date'].disable();
      this.mapping['meter_InitialReadingDate'].disable();
      console.log(this.metersDBData?.projectId);
      // ✅ When projectId exists → clear all validators
      const fieldsToClear = [
        'initialReading',
        'meter_Initial_Reading_EB_KWH',
        'meter_Initial_Reading_DG_KWH',
        'meter_Initial_Reading_Solar_KWH',
        'meterReadingIndex',
        'installed_Location',
        'meterInstallation_Date',
        'meter_InitialReadingDate',
      ];

      fieldsToClear.forEach((field) => {
        if (this.mapping[field]) {
          this.mapping[field].clearValidators();
          this.mapping[field].updateValueAndValidity();
        }
      });
    }
  }

  get mapping() {
    return this.mappingDBMetersForm.controls;
  }
  get f() {
    return this.editDBMetersForm.controls;
  }
  isAgentAdmin(): boolean {
    const role = this.currentUser?.currentUserRoleDetails?.role;
    const normalize = (value: any) =>
      value?.toString().trim().toLowerCase().replace(/[\s_-]/g, '');
    return normalize(role) === normalize(Roles.AGENTADMIN);
  }
  private isSuperAdminOrSuperUser(): boolean {
    const role = this.currentUser?.currentUserRoleDetails?.role;
    const normalizedRole = role?.toString().trim().toLowerCase().replace(/[\s_-]/g, '');
    return [Roles.SUPERADMIN, Roles.SUPERUSER].some(
      (superRole) => superRole.toLowerCase().replace(/[\s_-]/g, '') === normalizedRole,
    );
  }
  isLocationCoordinatesDisabled(): boolean {
    // Agent Admins cannot edit coordinates, including on rejected meters.
    if (this.isAgentAdmin()) {
      return true;
    }

    if (this.metersDBData?.approvalStatus === 'Rejected') {
      return false;
    }

    return this.isSuperAdminOrSuperUser() && this.isMeterMapped();
  }
  preventManualInput(event: KeyboardEvent): void {
    // Prevent all keys except Tab and Arrow keys, which are essential for navigating
    const allowedKeys = [
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
    ];
    if (!allowedKeys.includes(event.key)) {
      event.preventDefault(); // Prevent input
    }
  }
  clearDate_meter() {
    // this.selectedDate = null; // Clear the selected date
    this.mappingDBMetersForm.controls['meterInstallation_Date'].setValue(null);
  }

  openCalendar() {
    // Trigger the click event on the input field to open the datepicker
    const dateInput = document.querySelector('.form-control.date');
    dateInput?.dispatchEvent(new Event('click'));
  }
  clearDategas_Initial_meter() {
    this.mappingDBMetersForm.controls['meter_InitialReadingDate'].setValue(
      null,
    );
  }

  mappingHistoryExportData: any[] = [];
  exportAll() {
    // this.getMappingHistory();
    this.loaderService.setLoading(true);
    this.meterService
      .getmappingHistorybaseUrl(
        this.meterId,
        1,
        this.totalMasterCount,
        this.searchedValue,
        this.queryString,
        this.orderByQuery,
      )
      .subscribe({
        next: (res) => {
          if (res.statusCode == 200) {
            this.mappingHistoryExportData = [];
            if (res.data.items.length > 0) {
              this.mappingHistoryExportData = [...res.data.items];
              const transformedData = this.mappingHistoryExportData.map(
                (item: any) => ({
                  'Mac Address': item.macAddress,
                  'Device Sr No': item.deviceSerialNumber,
                  Utility: item.utility,
                  'Is Wired': item.isWired ? 'Yes' : 'No',
                  'Device Id ': item.deviceId,
                  'Residential Unit': item.flatNo,
                  'Gateway Serial Number': item.gatewaySerialNumber,
                  Reason: item.reason,
                  'Action Date': this.sharedService.dateFormateChnage(
                    item.actionDate,
                  ),

                  'Action By': item.actionBy,
                  Action: item.action,
                }),
              );
              this.loaderService.setLoading(false);
              this.pdfexportService.downloadExcel(
                transformedData,
                'Mapping History',
              );
            } else {
              this.loaderService.setLoading(false);
              this.sharedService.showMessageDialog(
                'No data to display',
                '',
                SweetAlertIcon.ERROR,
              );
            }
          } else {
            this.loaderService.setLoading(false);
            this.sharedService.showMessageDialog(
              'No data to display',
              '',
              SweetAlertIcon.ERROR,
            );
          }
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);

          // Check if backend returned an error.message
          const errorMsg =
            err.error?.message ||
            'Something went wrong. Please try again later.';

          this.sharedService.showMessageDialog(
            errorMsg,
            '',
            SweetAlertIcon.ERROR,
          );
        },
      });
  }

  tabChange(event: any) {
    console.log(event);
    // console.log(this.metersDBData?.mappingDetails);
    this.submitted = false;
    this.isSubmitted = false;

    if (event.selectedIndex == 1) {
      // When returning to the mapping tab, reset the upload UI state so the
      // Map button is enabled again.
      this.pendingPhotoIds.clear();
      this.uploadingPhotoCount = 0;
      this.isUploading = false;

      if (
        this.metersDBData?.approvalStatus !== 'Rejected' &&
        this.metersDBData?.mappingDetails?.projectID
      ) {
        this.getConfigDatabyProject(
          this.metersDBData?.mappingDetails.projectID,
        );
        this.mappingDBMetersForm.patchValue({
          projectIds: this.metersDBData?.mappingDetails.projectID,
          // residentialUnit: this.metersDBData.projectId,
        });
      }
    }
    if (event.selectedIndex == 2) {
      this.getMappingHistory();
    }
  }

  changeGateways(event: any) {
    console.log(event);
    this.selectedGateways = event;
  }
  resetsFields() {
    // Do not patch/reset the Kendo Upload `files` control here.
    // Changing that control while an upload is in progress can cancel the
    // active upload when the Project selection changes.
    this.mappingDBMetersForm.patchValue({
      residentialUnit: null,
      gatewayInformationId: null,
      location: '',
      installed_Location: '',
      meterReadingIndex: '',
      initialReading: '',
      meter_Initial_Reading_EB_KWH: 0,
      meter_Initial_Reading_DG_KWH: 0,
      meter_Initial_Reading_Solar_KWH: 0,
      meterInstallation_Date: null,
      meter_InitialReadingDate: null,
    });
  }
  changeResidentialUnit(event: any) {
    console.log(event);

    this.selectedresidenatilUnit = event;
    console.log(this.selectedresidenatilUnit);
    this.fileImages = [];
    this.mappingDBMetersForm.patchValue({
      gatewayInformationId: null,

      //files: this.fileImages,
      location: '',
      installed_Location: '',
      initialReading: '',
      meter_Initial_Reading_EB_KWH: 0,
      meter_Initial_Reading_DG_KWH: 0,
      meter_Initial_Reading_Solar_KWH: 0,
      meterInstallation_Date: null,
      meter_InitialReadingDate: null,
    });
    console.log('Changed?', this.isMapResidenatiUnit);
  }
  changeUtility(event: any) {
    if (event == undefined) {
      this.waterTypeItems = [];
      this.editDBMetersForm.get('supplierId')?.setValue(null);
    } else {
      this.waterTypeItems = [];
      this.editDBMetersForm.get('supplierId')?.setValue(null);
      this.waterTypeItems = this.configData?.suppliers.filter((item: any) => {
        return item.master.name.toLowerCase() === event.name.toLowerCase();
      });
    }
    console.log(event);
    this.selectedutlity = event ?? { id: null, name: '' };
    console.log(this.selectedutlity);
    this.iswirdeCommunication = false;
    this.editDBMetersForm.get('isWiredCommunicationDevice')?.setValue(false);
    this.editDBMetersForm.get('deviceId')?.setValue('');
    console.log(this.waterTypeItems);
    // console.log(this.DBMetersForm.get('utilityMasterId')?.value);
    this.f['macAddress'].setValidators([
      Validators.required,
      Validators.pattern(this.Macregex),
      Validators.maxLength(16),
      Validators.minLength(16),
    ]);
    this.f['meterSerialNo'].setValidators([
      Validators.required,
      Validators.pattern(this.regex),
      Validators.maxLength(16),
      Validators.minLength(7),
    ]);
    this.f['macAddress'].updateValueAndValidity();
    this.f['meterSerialNo'].updateValueAndValidity();
    this.f['deviceId'].clearValidators(); // Remove validators
    this.f['deviceId'].updateValueAndValidity();
    this.editDBMetersForm.updateValueAndValidity();
    this.utilityBasedValidation();
  }

  getConfigDatabyProject(projectId: any): void {
    this.loaderService.setLoading(true);

    this.meterService.getProjectDetailsbaseUrl(projectId).subscribe({
      next: (res) => {
        if (res.statusCode === 200) {
          this.loaderService.setLoading(false);
          console.log(res);
          this.conficdatabyProject = res.data;
          this.Project_startDate = this.conficdatabyProject?.projectStartDate;
          console.log(this.conficdatabyProject);
          console.log(this.conficdatabyProject.gateways);

          //console.log(this.Project_startDate);
          const Project_startDate =
            this.Project_startDate != null
              ? new Date(this.Project_startDate)
              : null;
          this.minDate = Project_startDate ?? this.today;
          // console.log(Project_startDate);
          // console.log(this.minDate);
          this.metresdatePickerConfig = {
            containerClass: 'theme-dark-blue',
            rangeSeparator: ' to ',
            dateInputFormat: 'DD/MM/YYYY',
            minDate: this.minDate,
            maxDate: new Date(),
            showWeekNumbers: false,

            // other configurations as needed
          };
          console.log(this.conficdatabyProject?.residentialUnits.length);
          this.loaderService.setLoading(false);
        }
      },
      error: (err) => {
        console.log(err);
        this.loaderService.setLoading(false);

        // Check if backend returned an error.message
        const errorMsg =
          err.error?.message || 'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR,
        );
      },
    });
  }
  public onFilterProjectsChange(searchTerm: any): void {
    console.log(searchTerm);
    this.resetsFields();
    if (searchTerm != undefined) {
      console.log(searchTerm);
      // Convert searchTerm to a string, default to an empty string if it's not valid
      const term = typeof searchTerm === 'string' ? searchTerm : '';
      const contains =
        (value: string) => (item: { name: string; id: string }) =>
          item.name.toLowerCase().includes(value.toLowerCase());

      // Check if configData, data, and projects exist before filtering
      if (this.configData?.data?.projects) {
        this.configData.data.projects = this.configData.data.projects.filter(
          contains(term),
        );
      }
      this.getConfigDatabyProject(searchTerm.id);
    } else {
      this.conficdatabyProject = [];
      /* this.mappingDBMetersForm.patchValue({
        // projectIds: null,
        residentialUnit: null,
        gatewayInformationId: null,
        location: '',
      }); */
    }
  }

  public imageSrc: string | ArrayBuffer | null = null;
  public imagePreviews: Array<string | ArrayBuffer> = [];
  // Keeps uploaded file ids aligned with local preview entries.
  // null entries represent images that came from the server.
  private imagePreviewFileIds: Array<string | null> = [];
  public selectedImagePreview: string | ArrayBuffer | null = null;

  private getFilePreviewId(file: any): string | null {
    if (!file) {
      return null;
    }

    return (
      file.uid ??
      [
        file.name,
        file.rawFile?.size ?? file.size,
        file.rawFile?.lastModified,
      ].join('-')
    );
  }

  private syncMapUploadState(): void {
    this.isUploading = this.pendingPhotoIds.size > 0;
  }

  handleFileSelected(event: any): void {
    const allowedExtensions = ['.jpg', '.jpeg', '.png'];

    const validFiles: any[] = [];
    const invalidTypeFiles: string[] = [];
    const oversizedFiles: string[] = [];

    event.files.forEach((file: any) => {
      const fileName = file?.name ?? '';

      const extension = fileName
        .substring(fileName.lastIndexOf('.'))
        .toLowerCase();

      const fileSize = file?.rawFile?.size ?? file?.size ?? 0;

      // Validate extension
      if (!allowedExtensions.includes(extension)) {
        invalidTypeFiles.push(fileName);
        return;
      }

      // Validate size
      if (fileSize > this.maxPhotoSize) {
        oversizedFiles.push(fileName);
        return;
      }

      validFiles.push(file);
    });

    // Show error and STOP KENDO from accepting/uploading the selection.
    if (invalidTypeFiles.length > 0 || oversizedFiles.length > 0) {
      if (invalidTypeFiles.length > 0) {
        this.sharedService.showMessageDialog(
          `Only JPG, JPEG, and PNG files are allowed. Invalid file(s): ${invalidTypeFiles.join(', ')}`,
          '',
          SweetAlertIcon.ERROR,
        );
      }

      if (oversizedFiles.length > 0) {
        this.sharedService.showMessageDialog(
          `Photo Size Should Be 5 MB or Smaller`,
          '',
          SweetAlertIcon.ERROR,
        );
      }

      event.preventDefault();
      return;
    }

    // Only valid files come here.
    const newFiles = validFiles.filter(
      (file: any) =>
        !this.files.some(
          (existingFile: any) =>
            this.getFilePreviewId(existingFile) === this.getFilePreviewId(file),
        ),
    );

    if (!newFiles.length) {
      return;
    }

    if (this.imagePreviews.length + newFiles.length > this.maxPhotoCount) {
      this.sharedService.showMessageDialog(
        `You can upload a maximum of ${this.maxPhotoCount} photos.`,
        '',
        SweetAlertIcon.ERROR,
      );
      event.preventDefault();
      return;
    }

    // Disable Map immediately when a valid file is selected,
    // even before Kendo starts the actual upload request.
    newFiles.forEach((file: any) => {
      const fileId = this.getFilePreviewId(file);

      if (fileId) {
        this.pendingPhotoIds.add(fileId);
      }
    });

    this.uploadingPhotoCount = this.pendingPhotoIds.size;
    this.syncMapUploadState();

    this.files = [...this.files, ...newFiles];

    const previewPromises = newFiles.map(
      (file: any) =>
        new Promise<string | ArrayBuffer>((resolve, reject) => {
          const reader = new FileReader();

          reader.onload = () => {
            if (reader.result) {
              resolve(reader.result);
            } else {
              reject(new Error(`Unable to read ${file.name}`));
            }
          };

          reader.onerror = () => reject(reader.error);

          reader.readAsDataURL(file.rawFile);
        }),
    );

    Promise.all(previewPromises)
      .then((newPreviews) => {
        const activePreviews = newPreviews
          .map((preview, index) => ({
            preview,
            fileId: this.getFilePreviewId(newFiles[index]),
          }))
          .filter(
            ({ fileId }) =>
              !!fileId &&
              this.files.some(
                (file: any) => this.getFilePreviewId(file) === fileId,
              ),
          );

        this.imagePreviews = [
          ...this.imagePreviews,
          ...activePreviews.map(({ preview }) => preview),
        ];

        this.imagePreviewFileIds = [
          ...this.imagePreviewFileIds,
          ...activePreviews.map(({ fileId }) => fileId),
        ];

        this.currentImageIndex = 0;
        this.imageSrc = this.imagePreviews[this.currentImageIndex] ?? null;
      })
      .catch((error) => {
        console.error('Unable to generate photo preview.', error);

        this.sharedService.showMessageDialog(
          'Unable to preview the selected photo.',
          '',
          SweetAlertIcon.ERROR,
        );
      });
  }

  previousImage(): void {
    if (this.imagePreviews.length <= 1 || this.currentImageIndex === 0) {
      return;
    }

    this.currentImageIndex -= 1;
    this.imageSrc = this.imagePreviews[this.currentImageIndex];
  }

  nextImage(): void {
    if (
      this.imagePreviews.length <= 1 ||
      this.currentImageIndex === this.imagePreviews.length - 1
    ) {
      return;
    }

    this.currentImageIndex += 1;
    this.imageSrc = this.imagePreviews[this.currentImageIndex];
  }

  public onRemove(event: RemoveEvent): void {
    console.log('File removed:', event.files);

    const removedNames = new Set(
      event.files.map((file) => file.name).filter(Boolean),
    );
    const removedIds = new Set(
      event.files.map((file) => this.getFilePreviewId(file)).filter(Boolean),
    );

    // A removed file is no longer pending, so release the Map button.
    removedIds.forEach((fileId) => {
      if (fileId) {
        this.pendingPhotoIds.delete(fileId);
      }
    });

    this.uploadingPhotoCount = this.pendingPhotoIds.size;

    this.files = this.files.filter(
      (file) =>
        !removedIds.has(this.getFilePreviewId(file)) &&
        !(removedIds.size === 0 && removedNames.has(file.name)),
    );
    if (!this.files.length) {
      this.uploadLocked = false;
    }

    // Remove the matching local previews as well as the uploader entries.
    // Server-side images are kept because their preview-file id is null.
    this.imagePreviews = this.imagePreviews.filter((_preview, index) => {
      const fileId = this.imagePreviewFileIds[index];
      return fileId === null || !removedIds.has(fileId);
    });
    this.imagePreviewFileIds = this.imagePreviewFileIds.filter(
      (fileId) => fileId === null || !removedIds.has(fileId),
    );

    // If there are no local files left, rebuild the previews from the server
    // data so the original meter photos are still visible.
    if (!this.files.length) {
      this.setMeterPhotosFromResponse();
    }

    // Keep the selected index valid after a file is removed.
    this.currentImageIndex = Math.min(
      this.currentImageIndex,
      Math.max(this.imagePreviews.length - 1, 0),
    );
    this.imageSrc = this.imagePreviews[this.currentImageIndex] ?? null;

    this.syncMapUploadState();
  }

  public onUploadCancel(event: any): void {
    // Kendo cancel may not emit remove; clear the preview and pending state.
    this.onRemove(event as RemoveEvent);
  }

  handleFileRemoved(event: any) {
    console.log(event);
  }

  private files: any[] = [];

  onSelectFile(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      // this.file = event.target.files[0]
      var fromdate = new FormData();
      //this.invoiceAddForm.patchValue({ image: this.file });
      // fromdate.append('file', file);

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event) => {
        // called once readAsDataURL is completed
        this.url = event?.target?.result;
        console.log(this.url);
      };
    }
  }

  public onUpload(event?: UploadEvent): void {
    // Do not change the Map state here.
    // handleFileSelected() already disabled Map at selection time.
  }

  public onSuccess(event?: any): void {
    // A completed upload is no longer pending.
    const files = event?.files ?? [];

    files.forEach((file: any) => {
      const fileId = this.getFilePreviewId(file);

      if (fileId) {
        this.pendingPhotoIds.delete(fileId);
      }
    });

    if (files.length > 0) {
      // Keep Kendo's file list visible so its completed status can be seen,
      // while preventing the user from adding another upload.
      this.uploadLocked = true;
    }

    this.uploadingPhotoCount = this.pendingPhotoIds.size;
    this.syncMapUploadState();
  }

  public onUploadError(event?: any): void {
    // A failed upload is also considered finished,
    // so Map can be enabled once no other upload remains pending.
    const files = event?.files ?? [];

    files.forEach((file: any) => {
      const fileId = this.getFilePreviewId(file);

      if (fileId) {
        this.pendingPhotoIds.delete(fileId);
      }
    });

    this.uploadingPhotoCount = this.pendingPhotoIds.size;
    this.syncMapUploadState();
  }

  public isMapActionDisabled(): boolean {
    return this.pendingPhotoIds.size > 0;
  }

  public canShowMapAction(): boolean {
    return this.isUnmappedLocally || ['NotStarted', 'Rejected'].includes(
      this.metersDBData?.approvalStatus,
    );
  }

  public canShowUnmapAction(): boolean {
    return !this.isUnmappedLocally && this.metersDBData?.approvalStatus === 'Approved';
  }

  openImagePreview(template: any, image: string | ArrayBuffer) {
    const imageIndex = this.imagePreviews.findIndex(
      (preview) => preview === image,
    );
    if (imageIndex >= 0) {
      this.currentImageIndex = imageIndex;
      this.imageSrc = this.imagePreviews[this.currentImageIndex];
    }

    this.selectedImagePreview = image;
    this.imagePreviewModalRef = this.modalService.show(template, {
      class: 'modal-lg modal-dialog-centered meter-image-modal',
    });
  }

  private normalizeMeterPhotoDtos(photoUrls: any): MeterPhotoDto[] {
    if (!photoUrls) {
      return [];
    }

    if (Array.isArray(photoUrls)) {
      return photoUrls
        .map((photo) => {
          if (typeof photo === 'string') {
            return {
              id: '',
              fileName: this.getFileNameFromUrl(photo),
              photoUrl: photo,
            };
          }

          const photoUrl =
            photo?.photoUrl ??
            photo?.photoURL ??
            photo?.photo ??
            photo?.url ??
            photo?.fileUrl ??
            photo?.filePath ??
            photo?.path ??
            photo?.imageUrl ??
            '';

          return {
            id: photo?.id ?? '',
            fileName: photo?.fileName ?? this.getFileNameFromUrl(photoUrl),
            photoUrl,
          };
        })
        .map((photo) => ({
          ...photo,
          photoUrl: photo.photoUrl?.toString().trim() ?? '',
        }))
        .filter((photo) => !!photo.photoUrl);
    }

    if (typeof photoUrls === 'string') {
      return photoUrls
        .split(',')
        .map((url) => url.trim())
        .filter((url) => !!url)
        .map((url) => ({
          id: '',
          fileName: this.getFileNameFromUrl(url),
          photoUrl: url,
        }));
    }

    return [];
  }

  private setMeterPhotosFromResponse(): void {
    this.meterPhotos = this.normalizeMeterPhotoDtos(
      this.getMeterPhotoSource(this.metersDBData),
    );

    if (this.metersDBData) {
      this.metersDBData.photoUrl = this.meterPhotos;
    }

    this.imagePreviews = this.meterPhotos.map((photo) => photo.photoUrl);
    this.imagePreviewFileIds = this.imagePreviews.map(() => null);
  }

  private getMeterPhotoSource(meterData: any): any {
    const photoSources = [
      meterData?.photoUrl ?? null,
      meterData?.photoUrls ?? null,
      meterData?.meterDetails?.photoUrl ?? null,
      meterData?.meterDetails?.photoUrls ?? null,
      meterData?.meterDetail?.photoUrl ?? null,
      meterData?.meterDetail?.photoUrls ?? null,
      meterData?.details?.photoUrl ?? null,
      meterData?.details?.photoUrls ?? null,
    ];

    return (
      photoSources.find((photoSource) => {
        if (!photoSource) {
          return false;
        }

        return !Array.isArray(photoSource) || photoSource.length > 0;
      }) ?? []
    );
  }

  private normalizePhotoUrls(photoUrls: any): string[] {
    return this.normalizeMeterPhotoDtos(photoUrls).map(
      (photo) => photo.photoUrl,
    );
  }

  private getFileNameFromUrl(url: string): string {
    if (!url) {
      return '';
    }

    const path = url.split('?')[0];
    return path.substring(path.lastIndexOf('/') + 1);
  }
  findInvalidControls(form: any): { [key: string]: any }[] {
    const invalidControls = [];
    const controls = form.controls;

    for (const name in controls) {
      if (controls[name].invalid) {
        invalidControls.push({
          controlName: name,
          controlErrors: controls[name].errors,
        });
      }
    }

    return invalidControls;
  }
  upadteMetersDB() {
    this.isSubmitted = true;
    const invalidControls = this.findInvalidControls(this.mappingDBMetersForm);
    console.log(invalidControls);
    console.log(this.mappingDBMetersForm.valid);
    this.loaderService.setLoading(true);
    if (this.mappingDBMetersForm.invalid) {
      this.loaderService.setLoading(false);
      return;
    } else {
      let request = {};

      this.meterService
        .updateMtersDBIdeUrl(this.metersDBData.id, request)
        .subscribe({
          next: (res) => {
            console.log(res);
            if (res.statusCode == 200) {
              this.isMapResidenatiUnit = false;
              this.sharedService.showMessageDialog(
                'Success',
                res.message,
                SweetAlertIcon.SUCCESS,
              );
              this.loaderService.setLoading(false);
            }
          },
          error: (err) => {
            console.log(err);
            this.loaderService.setLoading(false);
          },
        });
    }
  }

  onCheckboxChange(event: any) {
    console.log(event.target.checked);
    this.iswirdeCommunication = event.target.checked;
    console.log(this.iswirdeCommunication);

    if (event.target.checked) {
      // When checkbox is checked, add the required validators
      this.f['macAddress'].setValidators([
        Validators.required,
        Validators.pattern(this.IsWiredMacregex),
        Validators.maxLength(7),
        Validators.minLength(7),
      ]);
      this.f['meterSerialNo'].setValidators([
        Validators.required,
        Validators.pattern(this.SerialIswired),
        Validators.maxLength(7),
        Validators.minLength(7),
      ]);
      this.f['deviceId'].setValidators([
        Validators.required,
        Validators.pattern(this.onlynumber),
      ]);
      this.f['macAddress'].updateValueAndValidity();
      this.f['meterSerialNo'].updateValueAndValidity();
      this.f['deviceId'].updateValueAndValidity(); // Ensure validity is updated
      this.editDBMetersForm.updateValueAndValidity();
    } else {
      // When checkbox is unchecked, clear the validators and update validity
      //console.log(this.iswirdeCommunication);

      // Update validity without triggering events
      this.iswirdeCommunication = false;
      this.f['deviceId'].setValue('');
      this.f['deviceId'].clearValidators(); // Remove validators
      this.f['macAddress'].setValidators([
        Validators.required,
        Validators.pattern(this.Macregex),
        Validators.maxLength(16),
        Validators.minLength(16),
      ]);
      this.f['meterSerialNo'].setValidators([
        Validators.required,
        Validators.pattern(this.regex),
        Validators.maxLength(16),
        Validators.minLength(7),
      ]);
      this.f['macAddress'].updateValueAndValidity();
      this.f['meterSerialNo'].updateValueAndValidity();
      this.f['deviceId'].updateValueAndValidity({}); // Update validity without triggering events
      this.editDBMetersForm.updateValueAndValidity();
    }
  }

  UpdateDBMeters() {
    console.log('NewMeters');
    this.submitted = true;
    this.editDBMetersForm.updateValueAndValidity();
    console.log(this.editDBMetersForm.invalid);
    console.log(this.editDBMetersForm.get('meterSerialNo')?.value);
    const invalidControls = this.findInvalidControls(this.editDBMetersForm);
    console.log(invalidControls);
    this.loaderService.setLoading(true);
    console.log(invalidControls);
    const isWired =
      this.editDBMetersForm.get('isWiredCommunicationDevice')?.value ?? false;
    const deviceId = isWired
      ? this.editDBMetersForm.get('deviceId')?.value
      : '';
    if (this.editDBMetersForm.invalid) {
      this.loaderService.setLoading(false);
      return;
    } else {
      const metersRawValues = { ...this.editDBMetersForm.getRawValue() };
      console.log(metersRawValues);
      let request = {
        utilityMasterId: this.selectedutlity.id,
        macAddress: this.editDBMetersForm.get('macAddress')?.value,
        meterSerialNo: this.editDBMetersForm.get('meterSerialNo')?.value,
        currentUtilityType: this.selectedutlity.name,
        isWiredCommunicationDevice: this.editDBMetersForm.get(
          'isWiredCommunicationDevice',
        )?.value,
        deviceId: deviceId,
        userID: this.userId,
        // supplierId: this.editDBMetersForm.get('supplierId')?.value?? null,
        // Latitude: this.editDBMetersForm.get('latitude')?.value,
        // Longitude: this.editDBMetersForm.get('longitude')?.value,
        // photo: metersRawValues.files?.[0]?.rawFile,
      };
      let formData = new FormData();

      (Object.keys(request) as (keyof typeof request)[]).forEach((key) => {
        const value = request[key];
        if (value !== null && value !== undefined) {
          formData.append(key, String(value)); // ✅ ensure string type
        }
      });
      formData.append(
        'supplierId',
        this.editDBMetersForm.get('supplierId')?.value ?? '',
      );
      //  formData.append('photo', metersRawValues.files?.[0]?.rawFile ?? '');
      console.log(request);
      this.meterService
        .updateMtersDBIdeUrl(this.metersDBData?.id, formData)
        .subscribe({
          next: (res) => {
            console.log(res);
            if (res.statusCode == 200) {
              this.clearSelectedPhotos();
              console.log(res);
              this.getmetersDbByid();
              this.sharedService.showMessageDialog(
                'Success',
                res.message,
                SweetAlertIcon.SUCCESS,
              );
              this.meterId = res.data.id;
              this.macAddress = res.data.macAddress;
              this.loaderService.setLoading(false);
            }
          },
          error: (err) => {
            const errorMsg = err.error?.message
              ? err.error.message
              : err.message;

            this.sharedService.showMessageDialog(
              'Error',
              errorMsg,
              SweetAlertIcon.ERROR,
            );

            console.log(err);
            this.loaderService.setLoading(false);
          },
        });
    }
  }

  /* Mapping History start  */

  getMappingHistory() {
    this.loaderService.setLoading(true);
    this.meterService
      .getmappingHistorybaseUrl(
        this.meterId,
        this.currentPage,
        this.pageSize,
        this.searchedValue,
        this.queryString,
        this.orderByQuery,
      )
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if (res.statusCode == 200) {
            this.loaderService.setLoading(false);
            console.log(res);
            this.meterDBlistList = [...res.data.items];
            this.pageSize = res.data.pageSize;
            this.totalMasterCount = res.data.totalCount;
            console.log(this.totalMasterCount);
            this.loadMterConfig();
          }
        },
        error: (err: any) => {
          this.loaderService.setLoading(false);
          console.log(err);
        },
      });
  }
  private loadMterConfig(): void {
    const state: State = {
      take: this.pageSize,
      sort: this.sort,
      filter: {
        logic: 'and',
        filters: [],
      } as CompositeFilterDescriptor, // Providing a valid filter
    };

    const processedData = process(this.meterDBlistList, state);
    this.meterDBgridData = {
      data: processedData.data,
      total: this.totalMasterCount,
    };
    this.meterDBgridData.data = this.meterDBgridData?.data.map((item) => {
      return {
        ...item,
        is_wired: item.isWired ? 'Yes' : 'No',
        Action_date: this.sharedService.dateFormateChnage(item.actionDate),
      };
    });
    console.log(this.meterDBgridData);
  }

  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;
    // Check if the element is a table cell
    if (element.nodeName === 'TD') {
      const cellValue = element.innerText.trim();

      // Only show the tooltip if the cell is not empty, null, or ''
      if (cellValue && !element.closest('.no-tooltip')) {
        this.tooltipDir?.toggle(element);
      } else {
        this.tooltipDir?.hide();
      }
    } else if (element.classList.contains('k-column-title')) {
      this.tooltipDir?.toggle(element);
    } else {
      this.tooltipDir?.hide();
    }
  }

  public onMeterFilterChange(filter: CompositeFilterDescriptor): void {
    //  console.log(filter)
    this.meterState.filter = filter;
    this.skip = 0;
    let isFilter = filter.filters.length > 0 ? true : false;
    localStorage.setItem('filter', JSON.stringify(isFilter));
    this.sharedService.setFilter(filter);
    const queryString = this.sharedService.createQuery(this.meterState);
    this.queryString = this.sharedService.createQuery(this.meterState);
    this.getMappingHistory();
  }

  protected meterConfigPageChange({ skip, take }: PageChangeEvent): void {
    console.log('>>>', skip, take);
    this.mySelectionMeter = [];
    this.skip = skip;
    this.pageSize = take;
    this.currentPage = Math.floor(skip / take) + 1;
    console.log('currentpage', Math.floor(skip / take) + 1);

    this.getMappingHistory();

    // this.loadMterConfig();
  }

  protected dataStateChange(state: DataStateChangeEvent): void {
    console.log('saAK', JSON.stringify(state.filter));
    this.sort = state.sort || [];
    this.filter = state.filter || { logic: 'and', filters: [] };
    console.log('datastatechange' + JSON.stringify(this.filter));
  }
  public selectionChanged(selection: any) {
    // Handle deselected rows
    selection.deselectedRows.forEach((row: any) => {
      const index = this.mySelectionMeter.findIndex(
        (selectedRow: any) => selectedRow.id === row.dataitem?.id,
      );
      if (index > -1) {
        this.mySelectionMeter.splice(index, 1);
      }
    });

    // Handle selected rows
    selection.selectedRows.forEach((row: any) => {
      if (!this.isMasterRowSelected(row.dataItem)) {
        this.mySelectionMeter.push(row.dataItem);
      }
    });

    console.log(this.mySelectionMeter);
  }
  public isMasterRowSelected = (rowArg: any) => {
    return this.mySelectionMeter.some((row: any) => row.id === rowArg.id);
  };
  onSortChange(sort: SortDescriptor[]): void {
    this.meterState.sort = sort;
    console.log(this.meterState.sort);
    const orderByQuery = this.sharedService.createOrderByQuery(
      this.meterState.sort,
    );

    this.orderByQuery = orderByQuery;
    this.getMappingHistory();
  }

  public onValueChange(ev: string): void {
    console.log(ev);
    if (ev.length == 0) {
      this.searchModifiedData = '';
      this.meterConfigPageChange({ skip: 0, take: this.pageSize });
      this.getMappingHistory();
    }
  }
  onMeterConfigFilter(value: any): void {
    this.searchModifiedData = this.searchedValue;

    this.searchModifiedData = this.searchedValue;
    this.meterConfigPageChange({ skip: 0, take: this.pageSize });
    //this.getAllMeterConfigurations();
  }

  onSearchMeterAds(): void {
    if (this.searchedValue.length > 0) {
      this.getMappingHistory();
    }
  }
  onMeterExport() {
    if (this.meterDBgridData.data.length > 0) {
      setTimeout(() => {
        this.hiddenGrid?.saveAsExcel();
      }, 1000);
    }
  }

  mapUmpConfirmation(type: string) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });
    let text = '';
    if (type === 'map') {
      text = 'Are you sure you want to Map this Meter?';
    } else if (type === 'unmap') {
      text = `A Statement will be generated upon unlinking this meter to this Residential Unit. Are you sure you want to unlink this Meter?`;
    }
    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: text,
        icon: 'warning',
        confirmButtonText: 'Yes, Proceed',
        cancelButtonText: 'No, Cancel',
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          if (type == 'map') {
            this.mapProject();
          } else {
            this.unmapProject();
          }
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
        }
      });
  }

  /* map Details Start  */
  mapProject() {
    this.loaderService.setLoading(true);
    const metersRawValues = { ...this.mappingDBMetersForm.getRawValue() };
    this.isSubmitted = true;
    const invalidControls = this.sharedService.findInvalidControls(
      this.mappingDBMetersForm,
    );
    console.log('Invalid controls:', invalidControls);
    console.log(this.files);
    console.log(metersRawValues);
    if (this.mappingDBMetersForm.invalid) {
      this.loaderService.setLoading(false);
      return;
    } else {
      let request = {
        meterId: this.meterId,
        macAddress: this.macAddress,
        projectId: this.mappingDBMetersForm.get('projectIds')?.value ?? null,
        residentialUnitId:
          this.mappingDBMetersForm.get('residentialUnit')?.value ?? null,
        userId: this.userId,
        mapType: 'map',
        gatewayInformationId:
          this.mappingDBMetersForm.get('gatewayInformationId')?.value ?? null,
        gatewayName: this.selectedGateways?.gatewaySerialNumber,
        location: this.mappingDBMetersForm.get('location')?.value,

        initialReading:
          this.mappingDBMetersForm.get('initialReading')?.value === ''
            ? 0
            : this.mappingDBMetersForm.get('initialReading')?.value,
        meterReadingIndex:
          this.mappingDBMetersForm.get('meterReadingIndex')?.value ?? '',
        installedLocation:
          this.mappingDBMetersForm.get('installed_Location')?.value,

        meterInitialReadingSolarKWH:
          this.mappingDBMetersForm.get('meter_Initial_Reading_Solar_KWH')
            ?.value === ''
            ? 0
            : this.mappingDBMetersForm.get('meter_Initial_Reading_EB_KWH')
                ?.value,

        meterInitialReadingDGKWH:
          this.mappingDBMetersForm.get('meter_Initial_Reading_DG_KWH')
            ?.value === ''
            ? 0
            : this.mappingDBMetersForm.get('meter_Initial_Reading_DG_KWH')
                ?.value,

        meterInitialReadingEBKWH:
          this.mappingDBMetersForm.get('meter_Initial_Reading_EB_KWH')
            ?.value === ''
            ? 0
            : this.mappingDBMetersForm.get('meter_Initial_Reading_EB_KWH')
                ?.value,

        InitialReadingDate: this.convertToUTC(
          this.mappingDBMetersForm.get('meter_InitialReadingDate')?.value ??
            null,
        ),
        meterInstallationDate: this.convertToUTC(
          this.mappingDBMetersForm.get('meterInstallation_Date')?.value ?? null,
        ),
      };
      let formData = new FormData();
      (Object.keys(request) as (keyof typeof request)[]).forEach((key) => {
        const value = request[key];
        if (value !== null && value !== undefined) {
          formData.append(key, String(value)); // ✅ ensure string type
        }
      });
      console.log(request);
      this.appendPhotos(formData);
      // console.log([...(formData as FormData).entries()]);
      this.meterService.mappUnMapbaseUrl(formData).subscribe({
        next: (res) => {
          console.log(res);
          if (res.statusCode == 200) {
            this.isUnmappedLocally = false;
            this.clearSelectedPhotos();
            this.meterId = res.data?.meterId ?? this.meterId;
            this.macAddress = res.data?.macAddress ?? this.macAddress;
            this.getmetersDbByid();
            this.cdkStepper.selectedIndex = 0;
            this.sharedService.showMessageDialog(
              res.message,
              '',
              SweetAlertIcon.SUCCESS,
            );
            this.loaderService.setLoading(false);
          }
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);

          // Check if backend returned an error.message
          const errorMsg =
            err.error?.message ||
            'Something went wrong. Please try again later.';

          this.sharedService.showMessageDialog(
            errorMsg,
            '',
            SweetAlertIcon.ERROR,
          );
        },
      });
    }
  }

  unmapProject() {
    this.loaderService.setLoading(true);
    const metersRawValues = { ...this.mappingDBMetersForm.getRawValue() };
    const invalidControls = this.sharedService.findInvalidControls(
      this.mappingDBMetersForm,
    );
    console.log('Invalid controls:', invalidControls);
    console.log(this.files);
    console.log(metersRawValues);
    this.isSubmitted = true;
    console.log(this.mappingDBMetersForm.invalid);
    if (this.mappingDBMetersForm.invalid) {
      this.loaderService.setLoading(false);
      return;
    } else {
      let request = {
        meterId: this.meterId,
        macAddress: this.macAddress,
        projectId: this.mappingDBMetersForm.get('projectIds')?.value ?? null,
        residentialUnitId:
          this.mappingDBMetersForm.get('residentialUnit')?.value ?? null,
        userId: this.userId,
        mapType: 'unmap',
        gatewayInformationId:
          this.mappingDBMetersForm.get('gatewayInformationId')?.value ?? null,
        gatewayName: this.selectedGateways?.gatewaySerialNumber,
        location: this.mappingDBMetersForm.get('location')?.value,

        initialReading:
          this.mappingDBMetersForm.get('initialReading')?.value === ''
            ? 0
            : this.mappingDBMetersForm.get('initialReading')?.value,
        meterReadingIndex:
          this.mappingDBMetersForm.get('meterReadingIndex')?.value ?? '',
        installedLocation:
          this.mappingDBMetersForm.get('installed_Location')?.value,

        meterInitialReadingSolarKWH:
          this.mappingDBMetersForm.get('meter_Initial_Reading_Solar_KWH')
            ?.value === ''
            ? 0
            : this.mappingDBMetersForm.get('meter_Initial_Reading_EB_KWH')
                ?.value,

        meterInitialReadingDGKWH:
          this.mappingDBMetersForm.get('meter_Initial_Reading_DG_KWH')
            ?.value === ''
            ? 0
            : this.mappingDBMetersForm.get('meter_Initial_Reading_DG_KWH')
                ?.value,

        meterInitialReadingEBKWH:
          this.mappingDBMetersForm.get('meter_Initial_Reading_EB_KWH')
            ?.value === ''
            ? 0
            : this.mappingDBMetersForm.get('meter_Initial_Reading_EB_KWH')
                ?.value,

        InitialReadingDate: this.convertToUTC(
          this.mappingDBMetersForm.get('meter_InitialReadingDate')?.value ??
            null,
        ),
        meterInstallationDate: this.convertToUTC(
          this.mappingDBMetersForm.get('meterInstallation_Date')?.value ?? null,
        ),
      };
      let formData = new FormData();
      (Object.keys(request) as (keyof typeof request)[]).forEach((key) => {
        const value = request[key];
        if (value !== null && value !== undefined) {
          formData.append(key, String(value)); // ✅ ensure string type
        }
      });
      console.log(request);
      this.appendPhotos(formData);
      // console.log([...(formData as FormData).entries()]);
      this.meterService.mappUnMapbaseUrl(formData).subscribe({
        next: (res) => {
          console.log(res);
          if (res.statusCode == 200) {
            this.isUnmappedLocally = true;
            if (this.isSuperAdminOrSuperUser()) {
              this.mappingDBMetersForm.enable();
              this.mappingDBMetersForm.get('location')?.enable({ emitEvent: false });
              this.uploadLocked = false;
            }
            this.meterId = res.data?.meterId ?? this.meterId;
            this.macAddress = res.data?.macAddress ?? this.macAddress;
            this.getmetersDbByid();
            this.cdkStepper.selectedIndex = 0;
            this.sharedService.showMessageDialog(
              res.message,
              '',
              SweetAlertIcon.SUCCESS,
            );
            this.loaderService.setLoading(false);
          }
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);

          // Check if backend returned an error.message
          const errorMsg =
            err.error?.message ||
            'Something went wrong. Please try again later.';

          this.sharedService.showMessageDialog(
            errorMsg,
            '',
            SweetAlertIcon.ERROR,
          );
        },
      });
    }
  }
  maxLimitValidator(max: number) {
    return (control: AbstractControl) => {
      const value = parseFloat(control.value);
      return !isNaN(value) && value > max ? { maxLimit: true } : null;
    };
  }

  private appendPhotos(formData: FormData): void {
    if (!this.files?.length) {
      return;
    }

    this.files.forEach((file: any) => {
      if (file?.rawFile) {
        formData.append('photo', file.rawFile);
      }
    });
  }
  private clearSelectedPhotos(): void {
    this.files = [];
    this.fileImages = [];
    this.imagePreviewFileIds = [];
    this.mappingDBMetersForm.get('files')?.setValue([]);
    this.mappingDBMetersForm.get('files')?.markAsPristine();
    this.mappingDBMetersForm.get('files')?.markAsUntouched();
  }

  convertToUTC(date: string | Date): string {
    if (!date) return '';

    // Ensure it's always a Date object
    const parsedDate = new Date(date);

    if (isNaN(parsedDate.getTime())) {
      console.error('Invalid date:', date);
      return '';
    }

    const adjustedStartDate = new Date(
      parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000,
    );

    let selectedDate = adjustedStartDate.toISOString();
    console.log('UTC Converted:', selectedDate);
    return selectedDate;
  }

  saveReject() {
    this.modalRefReasons.hide();
    this.reject();
  }

  rejectModel(invalidBillModal: any) {
    // this.reason = '';
    this.modalRefReasons = this.modalService.show(invalidBillModal, {
      class: 'modal-dialog-centered',
    });
  }
  validateReason() {
    this.reasonError = this.reason.trim().length === 0;
  }
  getSelectedUtilityName(): string {
    return (
      this.selectedutlity?.name ??
      this.metersDBData?.currentUtilityType ??
      ''
    )
      .toString()
      .trim();
  }
  isGasUtility(): boolean {
    return this.getSelectedUtilityName().toLowerCase() === 'gas';
  }
  isGasOrWaterUtility(): boolean {
    const utilityName = this.getSelectedUtilityName().toLowerCase();
    return utilityName === 'gas' || utilityName === 'water';
  }
  isElectricityOrTriSourceUtility(): boolean {
    const utilityName = this.getSelectedUtilityName().toLowerCase();
    return utilityName === 'electricity' || utilityName === 'trisource';
  }
  isTriSourceUtility(): boolean {
    return this.getSelectedUtilityName().toLowerCase() === 'trisource';
  }
  isMeterMapped(): boolean {
    if (this.isUnmappedLocally) {
      return false;
    }
    const projectId =
      this.metersDBData?.projectId ??
      this.metersDBData?.mappingDetails?.projectID;

    return projectId !== null && projectId !== undefined && projectId !== '';
  }
  onImageError(event: any): void {
    console.error('Image failed to load:', event.target?.src);
  }
}
